"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FillFactory = void 0;
var factory_1 = require("../internal/factory");
var styled_components_1 = __importDefault(require("styled-components"));
exports.FillFactory = factory_1.factory({
    name: 'Fill',
    settings: {},
    $when: {},
    component: function () {
        return styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      /* Fill the specified amount within a flex context */\n      flex: 1 1 ", ";\n    "], ["\n      /* Fill the specified amount within a flex context */\n      flex: 1 1 ", ";\n    "])), function (p) { var _a; return (_a = p.amount) !== null && _a !== void 0 ? _a : 'auto'; });
    }
});
var templateObject_1;
